{
  "en": {
    "inspiration_list": {
      "actions": {
        "cancel": "Undo",
        "delete": "Delete",
        "deleteMultiple": "Delete...",
        "delete_cancel": "Cancel",
        "edit": "Edit",
        "new": "New photo album",
        "save": "Save",
        "submit": "Submit",
        "tickBoxesDeletion": "Tick the checkboxes of the files you would like to have deleted."
      },
      "attributes": {
        "name": "Name"
      },
      "info": "What do you like for your new home? Upload photos that inspire you! Albums let you organise them into different topics: kitchen, bathroom, furniture, ...",
      "labels": {
        "inspiration_list": "Inspiration Lists",
        "inspirationlist": "Inspiration Album",
        "inspirations": "Inspirations",
        "noInspirationLists": "No inspiration List yet",
        "noInspirations": "No inspirations yet"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Create different albums for your kitchen, bathroom, or furniture and upload photos that inspire you.",
            "title": "How will you decorate your new home?"
          }
        }
      },
      "validation": {
        "needTitle": "Title is required",
        "selectInspirationList": "Select at least 1 inspiration list"
      }
    }
  }
}